import * as Cesium from 'cesium';
export const STORAGE_KEY = 'landscope_unsaved_placemarks';
export const serializePlacemarksForStorage = (placemarks, projectId, existingJson) => {
    let existingItems = [];
    if (existingJson) {
        try {
            existingItems = JSON.parse(existingJson);
        }
        catch ( /* ignore */_a) { /* ignore */ }
    }
    const otherProjectItems = existingItems.filter(item => item.projectId !== projectId);
    const currentProjectItems = [];
    placemarks.forEach((p) => {
        const cart = Cesium.Cartographic.fromCartesian(p.position);
        currentProjectItems.push({
            id: p.id,
            name: p.name,
            lat: Cesium.Math.toDegrees(cart.latitude),
            lng: Cesium.Math.toDegrees(cart.longitude),
            color: p.color,
            projectId: p.projectId,
            icon: p.icon,
            showLabel: p.showLabel
        });
    });
    return [...otherProjectItems, ...currentProjectItems];
};
export const deserializeStoredPlacemarks = (stored, projectId) => {
    return stored
        .filter(s => s.projectId === projectId)
        .map(s => ({
        id: s.id,
        name: s.name,
        latitude: s.lat,
        longitude: s.lng,
        color: s.color,
        projectId: s.projectId,
        icon: s.icon,
        showLabel: s.showLabel
    }));
};
